/*
 * @providesModule SecureBankingDrawer
 */
import React from 'react';
import {View, Text, Linking} from 'react-native';
import SkillzSVG from 'SkillzSVG';
import {_m} from 'INTL';
import {styles, stylesFn} from 'SecureBankingDrawerStyles';
import {FooterToastDrawer} from '@skillz/ui';
import PushButton from 'PushButton';

type Props = {
  visible: boolean;
  onDismiss: () => void;
};

const SecureBankingDrawer = ({visible, onDismiss}: Props) => {
  return (
    <View style={stylesFn(visible).footerToastContainer}>
      <FooterToastDrawer
        visible={visible}
        onDismiss={onDismiss}
        onBeforeDismiss={onDismiss}
        onShow={() => {}}
        title={_m('Security Options')}
        maxHeight={411}
        gradientColors={['#FFF', '#FFF']}
        gradientLocations={[0, 1]}
        preventClose={false}
        headerTextStyleOverride={styles.securityDrawerTitle}
        headerContainerStyleOverride={styles.securityDrawerHeader}
      >
        <View style={[styles.securityDrawerContainer]}>
          <View style={styles.securityDrawerHeader}>
            <SkillzSVG source='icon_shield_checkmark.svg' style={styles.securityDrawerShieldIcon} />
            <Text style={styles.securityDrawerTitle} allowFontScaling={false}>
              Secure Payments
            </Text>
          </View>
          <View style={[styles.securityDrawerBodyContainer, {marginBottom: 32}]}>
            <Text style={styles.securityDrawerBodyText} allowFontScaling={false}>
              {_m(
                'Skillz partners with Aeropay to provide fast & secure\nbank payments and best-in-class encryption & security.'
              )}
            </Text>
            <Text style={styles.securityDrawerBodyText} allowFontScaling={false}>
              {_m(
                "When you link your bank, you'll be redirected to a\nsecure browser or bank app to log in directly through\nyour bank. Your credentials won't be stored or shared.\nYour information is used soley to confirm and secure\nyour transactions on the account(s)."
              )}
            </Text>
            <Text style={styles.securityDrawerBodyText} allowFontScaling={false}>
              {_m('Join millions of users connected on 12,000 banks with\nAeropay today.')}
            </Text>
            <Text
              style={styles.securityDrawerLinkText}
              allowFontScaling={false}
              onPress={() => Linking.openURL('https://www.aeropay.com/security')}
            >
              {_m('https://www.aeropay.com/security')}
            </Text>
          </View>
          <PushButton
            cornerRadius={39}
            colors={['#4990e8']}
            onPress={onDismiss}
            style={{paddingHorizontal: 10, height: 45, flexShrink: 0}}
            textStyle={styles.securityButtonText}
            title={_m('Continue')}
          />
        </View>
      </FooterToastDrawer>
    </View>
  );
};

export default SecureBankingDrawer;
